import {
  usePutProvidersUserIdProductivityoverrides,
  getGetProvidersUserIdQueryKey,
} from '@/api/generated/doctor/doctor'
import type { ChangeDoctorProductivityOverridesAdminApiInContract } from '@/api/generated/pwrdbyQuickMDAdminsApi.schemas'
import { useQueryClient } from '@tanstack/react-query'

/**
 * Persists provider productivity overrides.
 *
 * Replaces the `overwriteMemberProductivity` thunk + OVERWRITE_MEMBER_PRODUCTIVITY* reducer
 * flow. The old flow merged the response into Redux `members[userId]` and set an
 * `isProductivityOverwrittenSuccess` flag that closed the productivity popup; the caller now
 * reproduces the popup close + member refresh via the returned `onSuccess` callback.
 */
export function useOverwriteMemberProductivity(userId: string) {
  const queryClient = useQueryClient()
  const mutation = usePutProvidersUserIdProductivityoverrides()

  function mutate(
    requestBody: ChangeDoctorProductivityOverridesAdminApiInContract,
    opts?: { onSuccess?: () => void; onError?: (error: unknown) => void },
  ) {
    mutation.mutate(
      { userId, data: requestBody },
      {
        onSuccess: () => {
          void queryClient.invalidateQueries({ queryKey: getGetProvidersUserIdQueryKey(userId) })
          opts?.onSuccess?.()
        },
        onError: (error) => {
          opts?.onError?.(error)
        },
      },
    )
  }

  return { mutate, isPending: mutation.isPending }
}
